import { I18n } from "react-redux-i18n";

const consoleUserSearchFields = (searchFieldValues, entityList) => {
    return {
        rows: [{
            hasTopBreak: false,
            hasBottomBreak: false,
            fields: [{
                id: "username",
                label: I18n.t('consoleUser.list.username'),
                type: "text",
                value: searchFieldValues.username.value,
            }, {
                id: "entityId",
                label: I18n.t('consoleUser.list.entity'),
                type: "dropdown",
                value: searchFieldValues.entityId.value,
                data: entityList,
            }]
        }]
    }
};

export {
    consoleUserSearchFields
}